// Copyright (c) 2017 Deere & Company

export const openFile = (blob, fileName, mimeType) => {

    const newBlob = new Blob([blob], {
        type: mimeType
    });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {

        window.navigator.msSaveOrOpenBlob(newBlob, fileName);

        return;

    }

    const data = window.URL.createObjectURL(newBlob);

    const link = document.createElement('a');

    link.href = data;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {

        window.URL.revokeObjectURL(data);
        document.body.removeChild(link);

    }, 10);

};



// WEBPACK FOOTER //
// ./src/shared/services/open-file.js